import { AttributeDefinitionFieldType } from './zitoneoServicesTypes';

export interface ScraperCategory {
    IdServiceCategory: number;
    ServiceCategory: string;
    Icon: string;
    Services: ScraperService[];
}

export enum ScraperServiceStatus {
    NEW = 'new',
    EXISTING = 'existing',
}

export interface ScraperService {
    Id: string;
    IdServiceType: number;
    ServiceType: string;
    Status: ScraperServiceStatus;
    Checked: boolean;
    AttributeDefinitions: ScraperAttribute[];
}

export enum ScraperAttributeStatus {
    NEW = 'new',
    MATCHED = 'matched',
    CONFLICT = 'conflict',
}

export type ScraperAttributeValueSource = 'CurrentValue' | 'SuggestedValue';

export interface ScraperAttribute {
    Id: string;
    IdAttributeDefinition: number;
    AttributeDefinition: string;
    Status: ScraperAttributeStatus;
    Checked: boolean;
    Value: string;
    CurrentValue: string | null;
    SuggestedValue: string;
    SelectedValueSource: ScraperAttributeValueSource;
    FieldType: AttributeDefinitionFieldType;
}
